/**
 * bootLiveKeybindings — KeybindingManager + live remaps wire (SPY-113).
 */

import { KeybindingManager } from '../input/keybindingManager.js';
import { wireLiveKeyRemaps } from './wireLiveKeyRemaps.js';

export function bootLiveKeybindings({
  scoreboardWire,
  abilityCast,
  summonerSpellWire,
  onToggleRange,
  inputController
} = {}) {
  const keybindings = new KeybindingManager({
    onOpenScoreboard: scoreboardWire?.onOpenScoreboard,
    onCloseScoreboard: scoreboardWire?.onCloseScoreboard,
    onToggleRange,
    onActivateQ: abilityCast?.onActivateQ,
    onCastW: abilityCast?.onCastW,
    onCastE: abilityCast?.onCastE,
    onCastR: abilityCast?.onCastR,
    onCastD: () => summonerSpellWire?.onCastD?.(),
    onCastF: () => summonerSpellWire?.onCastF?.()
  });
  keybindings.init();
  const remaps = wireLiveKeyRemaps({
    keybindingManager: keybindings,
    inputController
  });
  return { keybindings, remaps };
}
